export default "https://cdn-static.gokick.com/assets/f85860d356d81c773b535a0002382fa42e6b6edf/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";